export default __webpack_public_path__ + "images/8ccce880fc3da7a33d9bbb86519dd0c9-top-pro-badge.svg";